var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 596 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.923 74.395C37.89 52.435 13.677 31.197 0 0v371h596c-165 0-362.987-41.008-400.156-70.588-26.054-20.735-32.452-46.138-40.106-76.524-5.994-23.801-12.759-50.659-30.343-80.725-16.776-28.685-39.956-49.018-62.471-68.768z",
    fill: "currentColor"
  })));
}
export default SvgUnionDesktop;